class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    document.documentElement.addEventListener("cart:update", this.#onCartUpdated);
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener("cart:update", this.#onCartUpdated);
  }

  get threshold() {
    return parseFloat(this.getAttribute('threshold'));
  }

  #onCartUpdated = (event) => {
    const cartTotal = parseFloat(event.detail?.cart?.total_price || 0);
    const progress = Math.min(cartTotal / this.threshold, 1);
    this.style.setProperty('--progress', progress);
  };
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}